<template>
  <div>
    <v-container fluid>
      <ValidationObserver ref="login" v-slot="{ invalid, validated, passes }">
        <v-form>
          <v-row>
          <v-col cols="12" class="d-flex pl-0">
            <span class="white--text pl-1">Please enter your Mobile Phone Number</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0 pt-0">
            <v-phone-input class="d-flex" ref="phoneInput" v-model="userProfileInfo.mobile"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" class="pl-0 pt-0">
            <v-btn
              v-if="inputIsReady" 
              id="custom-disabled" 
              color="#8eb8f6" 
              size="small"
              text
              :loading="loadingUpdateUserNumber"
              :disabled="disableRetry || !isPhoneNumberValid"
              @click="updateUserSettings"
            >
              {{ buttonText }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="pb-0 ">
          <v-col cols="6" class="pb-0">
            <ValidationProvider v-slot="{ errors }" name="verifyCode" rules="required">
              <v-text-field
                v-model.trim="verificationCode"
                :error-messages="errors"
                placeholder="Enter confirmation code"
                class="remove-padding"
                filled
                required
              />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" class="pt-0 pl-0">
            <v-btn
              id="custom-disabled" 
              color="#8eb8f6"
              text
              :loading="loadingVerification"
              :disabled="invalid || !validated || loading"
              @click.prevent="passes(verifyPhoneNumber)"
            >submit confirmation code</v-btn>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="3">
            <v-btn 
              color="#3db0ad"
              @click="$emit('back')"
            >
              back
            </v-btn>
          </v-col>
          <v-spacer/>
          <v-col cols="3">
            <v-btn 
              color="#3db0ad" 
              :disabled="!phoneIsVerified"
              :loading="setMfaLoading"
              @click="setMfaMethod"
            >
              next
            </v-btn>
          </v-col>
        </v-row>
          
        </v-form>
      </ValidationObserver>
		</v-container>
  </div>
</template>

<script>

import Auth from "@aws-amplify/auth";

import API from "@aws-amplify/api";

const API_NAME = "PVAPI";

export default {
	name: 'SetupSms',
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  
	data() {
		return {
      countryCode: '',
      errors: [],
      phoneNumber: '',
      verificationCode: '',
      profile: {},
      loading: false,
      userProfileInfo: {
				firstName: "",
				lastName: "",
				photo: "",
				telephone: "",
				mobile: ""
			},
      loadingUpdateUserNumber: false,
      attempt: 0,
      loadingUser: false,
      disableRetry: false,
      inputIsReady: false,
      loadingVerification: false,
      phoneIsVerified: false,
      setMfaLoading: false
		}
	},

  computed: {
    buttonText() {
      return this.attempt > 0 ? `I didn't receive a code - please resend` : 'Send a confirmation code to my phone now'
    },

    isPhoneNumberValid() {
      return this.$refs.phoneInput.$data.lazyPhone.valid
    }
  },

  watch: {
    user: {
      deep: true,
      handler() {
        this.getUser()
      }
    }
  },

  mounted() {
    this.getUser()

    this.$nextTick(()=>{
      let self = this

      if(self.$refs.phoneInput._data) {
        this.inputIsReady = true
      }
      
    });
  },

	methods: {
    async getUser() {
      this.loadingUser = true

      const session = await Auth.currentSession();
      const token = session.getAccessToken().getJwtToken();
      const email = this.user.hasOwnProperty('attributes') ? this.user.attributes.email : this.user.challengeParam.userAttributes.email
      const res = await API.get(API_NAME, `/user/${email}`, {
        headers: {
          Authorization: token
        }
      });
      this.profile = res;
      this.loadingUser = false
      return;
    },
    
    async verifyPhoneNumber() {
      // eslint-disable-next-line no-console
      console.log('verifyPhoneNumber')
      this.loadingVerification = true
      try {
        const verify = await Auth.verifyCurrentUserAttributeSubmit('phone_number', this.verificationCode)

        // eslint-disable-next-line no-console
        console.log('verify result', verify)
        if(verify && verify == 'SUCCESS') {
          this.phoneIsVerified = true
          this.$emit('phoneVerified', this.userProfileInfo.mobile)
        } else {
          this.errors = ['Invalid code - please try again']
          this.loadingVerification = false
          // eslint-disable-next-line no-console
          console.log('error verify', verify)
        }
      } catch (err) {
        this.errors = ['Invalid code - please try again']
        this.loadingVerification = false
        // eslint-disable-next-line no-console
        console.log('error verify', err)
      }
      

      this.loadingVerification = false
    },

    async updateUserSettings() {
      this.loadingUpdateUserNumber = true

      const session = await Auth.currentSession();
      const token = session.getAccessToken().getJwtToken();
      const email = this.user.hasOwnProperty('attributes') ? this.user.attributes.email : this.user.challengeParam.userAttributes.email
      const id = this.profile.Org.id;
      const updateUser = await API.put(API_NAME, `/org/${id}/users/${email}`, {
        body: this.userProfileInfo,
        headers: {
          Authorization: token
        }
      })
      // eslint-disable-next-line no-console
      console.log('updateUser', updateUser)
      
      this.loadingUpdateUserNumber = false
      this.attempt++

      if(this.attempt > 1) {
        this.disableRetry = true

        setTimeout(() => {
          this.disableRetry = false
        }, "10000");
      }
    },

    async setMfaMethod() {
      this.setMfaLoading = true
      const user = await Auth.currentAuthenticatedUser()
      const mfa = await Auth.setPreferredMFA(user, 'SMS')

      if(mfa == 'SUCCESS') {
        const userWithMFa = await Auth.currentAuthenticatedUser()
        // eslint-disable-next-line no-console
        console.log('userWithMFa', userWithMFa)
        this.$emit('proceed', userWithMFa)
      }
      this.setMfaLoading = false
    }
	}
}
</script>

<style lang="scss">
  .v-application--is-ltr .v-text-field .v-label {
    display: none !important;
  }

  .v-phone-input__country.v-input {
    min-width: 0;
    max-width: 57px;
    text-align: center;
    padding-right: 5px;
  }

  #custom-disabled.v-btn--disabled {
    color: grey !important;
  }
</style>